import type { ValidationErrors } from '../../../../../utils/validation';
import type { ICustomControlData } from './customControlData';
import { InputCheckbox } from '../../../../elements/common';
import { FlexColumns } from '../../../../elements/FlexColumns';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroup } from '../../../../elements/forms/HorizontalFormGroup';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { InputTextCheckbox } from '../../../../elements/InputTextCheckbox';

interface IMedicatieAddEditProps {
    customControlData: ICustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: (customControl: Partial<ICustomControlData>) => Promise<void>;
    validateOneCustomControl: (name: string) => Promise<void>;
}

export function MedicatieAddEdit(props: IMedicatieAddEditProps) {
    return (
        <HorizontalFormGroup
            hasErrors={
                props.errors.has('customControlData.medicatie.geenMedicatie') ||
                props.errors.has('customControlData.medicatie.antiStolling') ||
                props.errors.has('customControlData.medicatie.geenCardialeMedicatie') ||
                props.errors.has('customControlData.medicatie.aceRemmer') ||
                props.errors.has('customControlData.medicatie.antiAritmica') ||
                props.errors.has('customControlData.medicatie.calciumantagonist') ||
                props.errors.has('customControlData.medicatie.digitalis') ||
                props.errors.has('customControlData.medicatie.nitraten') ||
                props.errors.has('customControlData.medicatie.betaBlokker') ||
                props.errors.has('customControlData.medicatie.antiHypertensiva') ||
                props.errors.has('customControlData.medicatie.diuretica') ||
                props.errors.has('customControlData.medicatie.andersText')
            }
        >
            <FormLabel>Medicatie</FormLabel>
            <InputContainer>
                <FlexColumns sm={12}>
                    <InputCheckbox
                        checked={props.customControlData.medicatie.geenMedicatie}
                        error={props.errors.get('customControlData.medicatie.geenMedicatie')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, geenMedicatie: value },
                            })
                        }
                        text="Geen medicatie"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.antiStolling}
                        error={props.errors.get('customControlData.medicatie.antiStolling')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, antiStolling: value },
                            })
                        }
                        text="Antistolling"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.geenCardialeMedicatie}
                        error={props.errors.get('customControlData.medicatie.geenCardialeMedicatie')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, geenCardialeMedicatie: value },
                            })
                        }
                        text="Geen cardiale medicatie"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.aceRemmer}
                        error={props.errors.get('customControlData.medicatie.aceRemmer')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, aceRemmer: value },
                            })
                        }
                        text="Ace-remmer"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.antiAritmica}
                        error={props.errors.get('customControlData.medicatie.antiAritmica')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, antiAritmica: value },
                            })
                        }
                        text="Antiaritmica"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.calciumantagonist}
                        error={props.errors.get('customControlData.medicatie.calciumantagonist')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, calciumantagonist: value },
                            })
                        }
                        text="Calciumantagonist"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.digitalis}
                        error={props.errors.get('customControlData.medicatie.digitalis')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, digitalis: value },
                            })
                        }
                        text="Digitalis"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.nitraten}
                        error={props.errors.get('customControlData.medicatie.nitraten')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, nitraten: value },
                            })
                        }
                        text="Nitraten"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.betaBlokker}
                        error={props.errors.get('customControlData.medicatie.betaBlokker')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, betaBlokker: value },
                            })
                        }
                        text="Bètablokker"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.antiHypertensiva}
                        error={props.errors.get('customControlData.medicatie.antiHypertensiva')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, antiHypertensiva: value },
                            })
                        }
                        text="Antihypertensiva"
                    />
                    <InputCheckbox
                        checked={props.customControlData.medicatie.diuretica}
                        error={props.errors.get('customControlData.medicatie.diuretica')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, diuretica: value },
                            })
                        }
                        text="Diuretica"
                    />
                    <InputTextCheckbox
                        error={props.errors.get('customControlData.medicatie.andersText')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({
                                medicatie: { ...props.customControlData.medicatie, andersText: value },
                            })
                        }
                        onDoValidate={async () => await props.validateOneCustomControl('medicatie.andersText')}
                        placeholder="Anders, namelijk..."
                        text={props.customControlData.medicatie.andersText}
                    />
                </FlexColumns>
            </InputContainer>
        </HorizontalFormGroup>
    );
}
